import SettingsRepository from "../../repositories/settings.repository";

interface props {
    settingsRepository: SettingsRepository;
}
export default class LoadThemeUseCase {
    _settingsRepository: SettingsRepository;

    constructor(_: props) {
        this._settingsRepository = _.settingsRepository;
    }

    public call = async (): Promise<string> => {
        return this._settingsRepository.getCurrentTheme();
    }
}

export const LoadThemeUseCaseName = "LoadThemeUseCase";